export default __webpack_public_path__ + "static/media/Mark.059de4fb.jpg";